import React from "react";
import { Image as KonvaImage } from "react-konva";
import useImage from "use-image";

const Image = ({ title, url, props, height, width }) => {
  const [img] = useImage(url);

  return (
    <KonvaImage
      image={img}
      alt={title}
      {...props}
      width={width}
      height={height}
    />
  );
};
export default Image;
